// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_hn","advertDetailContactItem__link":"c-l_ho","advertDetailContactItem__stub":"c-l_hp"};